var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "market-list-form" },
    [
      _c(
        "el-radio-group",
        {
          staticStyle: { "margin-bottom": "30px" },
          attrs: { size: "small" },
          model: {
            value: _vm.activeSetting,
            callback: function ($$v) {
              _vm.activeSetting = $$v
            },
            expression: "activeSetting",
          },
        },
        [
          _c("el-radio-button", { attrs: { label: 1 } }, [_vm._v("内 容")]),
          _vm._v(" "),
          _c("el-radio-button", { attrs: { label: 2 } }, [_vm._v("样 式")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeSetting == 1,
              expression: "activeSetting==1",
            },
          ],
          attrs: { model: _vm.itemInfo, "label-width": "120px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "是否蛋糕主页：" } },
            [
              _c("el-checkbox", {
                staticStyle: { "margin-right": "80px" },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.isDangao,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "isDangao", $$v)
                  },
                  expression: "itemInfo.isDangao",
                },
              }),
              _vm._v(" "),
              _c("div", { staticStyle: { color: "#999" } }, [
                _vm._v("蛋糕主页需选择城市定位，不可展示logo"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.itemInfo.isDangao
            ? _c(
                "el-form-item",
                { attrs: { label: "城市文字颜色" } },
                [
                  _c("el-color-picker", {
                    attrs: { "show-alpha": "" },
                    on: { change: _vm.updateItem },
                    model: {
                      value: _vm.itemInfo.titleColor,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo, "titleColor", $$v)
                      },
                      expression: "itemInfo.titleColor",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticStyle: { color: "#999" } }, [
                    _vm._v("蛋糕主题城市定位文字颜色。"),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "是否展示定位" } },
            [
              _c("el-switch", {
                attrs: {
                  "active-color": "#13ce66",
                  size: "mini",
                  "active-value": true,
                  "active-text": "展示",
                  "inactive-text": "隐藏",
                  "inactive-value": false,
                  "inactive-color": "#ff4949",
                },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.newSwitch,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "newSwitch", $$v)
                  },
                  expression: "itemInfo.newSwitch",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.itemInfo.newSwitch
            ? _c("el-form-item", { attrs: { label: "展示logo：" } }, [
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c("el-checkbox", {
                      staticStyle: { "margin-right": "80px" },
                      on: { change: _vm.updateItem },
                      model: {
                        value: _vm.itemInfo.isLogo,
                        callback: function ($$v) {
                          _vm.$set(_vm.itemInfo, "isLogo", $$v)
                        },
                        expression: "itemInfo.isLogo",
                      },
                    }),
                    _vm._v(" "),
                    _vm.userType === 1
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "upLoadPicBox",
                                on: {
                                  click: function ($event) {
                                    return _vm.modalPicTap("1", "logoUrl")
                                  },
                                },
                              },
                              [
                                _vm.itemInfo.logoUrl
                                  ? _c("div", { staticClass: "pictrue" }, [
                                      _c("img", {
                                        attrs: { src: _vm.itemInfo.logoUrl },
                                      }),
                                    ])
                                  : _c("div", { staticClass: "upLoad" }, [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-camera cameraIconfont",
                                      }),
                                    ]),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.itemInfo.logoUrl
                              ? _c("i", {
                                  staticClass: "el-icon-delete",
                                  staticStyle: {
                                    color: "red",
                                    "font-size": "16px",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeImg("logoUrl")
                                    },
                                  },
                                })
                              : _vm._e(),
                          ]
                        )
                      : _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                            },
                          },
                          [
                            _c(
                              "el-upload",
                              {
                                staticClass: "avatar-uploader-small",
                                attrs: {
                                  action: "",
                                  "show-file-list": false,
                                  "http-request": function (options) {
                                    return _vm.handleLocalUpload(
                                      options,
                                      "logoUrl"
                                    )
                                  },
                                  "before-upload": _vm.beforeUpload,
                                  accept: "image/*",
                                },
                              },
                              [
                                _vm.itemInfo.logoUrl
                                  ? _c("img", {
                                      staticClass: "avatar-small",
                                      attrs: { src: _vm.itemInfo.logoUrl },
                                    })
                                  : _c("i", {
                                      staticClass:
                                        "el-icon-plus avatar-uploader-icon-small",
                                    }),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.itemInfo.logoUrl
                              ? _c("i", {
                                  staticClass: "el-icon-delete",
                                  staticStyle: {
                                    color: "red",
                                    "font-size": "16px",
                                    "margin-left": "10px",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeImg("logoUrl")
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "提示文字：" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入提示文字" },
                on: { blur: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.searchDefault,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "searchDefault", $$v)
                  },
                  expression: "itemInfo.searchDefault",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeSetting == 2,
              expression: "activeSetting==2",
            },
          ],
          attrs: { model: _vm.itemInfo, "label-width": "100px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "文字位置：" } },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.newTextPosition,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo, "newTextPosition", $$v)
                    },
                    expression: "itemInfo.newTextPosition",
                  },
                },
                _vm._l(_vm.placeholderPositionEnumText, function (rad) {
                  return _c(
                    "el-radio",
                    { key: rad.value, attrs: { label: rad.value } },
                    [_vm._v(_vm._s(rad.label))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "主题颜色：" } },
            [
              _c("el-color-picker", {
                attrs: { "show-alpha": "" },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.newTextColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "newTextColor", $$v)
                  },
                  expression: "itemInfo.newTextColor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "定位位置：" } },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.newDivPosistion,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo, "newDivPosistion", $$v)
                    },
                    expression: "itemInfo.newDivPosistion",
                  },
                },
                _vm._l(_vm.scorllRaiodText, function (rad) {
                  return _c(
                    "el-radio",
                    { key: rad.value, attrs: { label: rad.value } },
                    [_vm._v(_vm._s(rad.label))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.itemInfo.newDivPosistion == 3
            ? _c("el-form-item", { attrs: { label: "定位位置：" } }, [
                _c(
                  "div",
                  {
                    staticClass: "flex",
                    staticStyle: { "margin-bottom": "5px" },
                  },
                  [
                    _c("div", { staticStyle: { "margin-right": "10px" } }, [
                      _vm._v("上："),
                    ]),
                    _vm._v(" "),
                    _c("el-input-number", {
                      attrs: { min: 0 },
                      on: { change: _vm.updateItem },
                      model: {
                        value: _vm.itemInfo.fixedPt,
                        callback: function ($$v) {
                          _vm.$set(_vm.itemInfo, "fixedPt", $$v)
                        },
                        expression: "itemInfo.fixedPt",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "flex",
                    staticStyle: { "margin-bottom": "5px" },
                  },
                  [
                    _c("div", { staticStyle: { "margin-right": "10px" } }, [
                      _vm._v("左："),
                    ]),
                    _vm._v(" "),
                    _c("el-input-number", {
                      attrs: { min: 0 },
                      on: { change: _vm.updateItem },
                      model: {
                        value: _vm.itemInfo.fixedPl,
                        callback: function ($$v) {
                          _vm.$set(_vm.itemInfo, "fixedPl", $$v)
                        },
                        expression: "itemInfo.fixedPl",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "背景图片：" } }, [
            _vm.userType === 1
              ? _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "upLoadPicBox",
                        on: {
                          click: function ($event) {
                            return _vm.modalPicTap("1", "bgImg")
                          },
                        },
                      },
                      [
                        _vm.itemInfo.bgImg
                          ? _c("div", { staticClass: "pictrue" }, [
                              _c("img", { attrs: { src: _vm.itemInfo.bgImg } }),
                            ])
                          : _c("div", { staticClass: "upLoad" }, [
                              _c("i", {
                                staticClass: "el-icon-camera cameraIconfont",
                              }),
                            ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.itemInfo.bgImg
                      ? _c("i", {
                          staticClass: "el-icon-delete",
                          staticStyle: { color: "red", "font-size": "16px" },
                          on: {
                            click: function ($event) {
                              return _vm.removeImg("bgImg")
                            },
                          },
                        })
                      : _vm._e(),
                  ]
                )
              : _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c(
                      "el-upload",
                      {
                        staticClass: "avatar-uploader",
                        attrs: {
                          action: "",
                          "show-file-list": false,
                          "http-request": function (options) {
                            return _vm.handleLocalUpload(options, "bgImg")
                          },
                          "before-upload": _vm.beforeUpload,
                          accept: "image/*",
                        },
                      },
                      [
                        _vm.itemInfo.bgImg
                          ? _c("img", {
                              staticClass: "avatar",
                              attrs: { src: _vm.itemInfo.bgImg },
                            })
                          : _c("i", {
                              staticClass: "el-icon-plus avatar-uploader-icon",
                            }),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.itemInfo.bgImg
                      ? _c("i", {
                          staticClass: "el-icon-delete",
                          staticStyle: {
                            color: "red",
                            "font-size": "20px",
                            "margin-left": "10px",
                            cursor: "pointer",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.removeImg("bgImg")
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "upload-tip",
                        staticStyle: { "margin-left": "10px" },
                      },
                      [_vm._v("支持jpg、png格式，不超过2MB")]
                    ),
                  ],
                  1
                ),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "背景色：" } },
            [
              _c("el-color-picker", {
                attrs: { "show-alpha": "" },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.bgColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "bgColor", $$v)
                  },
                  expression: "itemInfo.bgColor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.itemInfo.position
            ? _c("el-form-item", { attrs: { label: "定位间距：" } }, [
                _c(
                  "div",
                  {
                    staticClass: "flex",
                    staticStyle: { "margin-bottom": "5px" },
                  },
                  [
                    _c("div", { staticStyle: { "margin-right": "10px" } }, [
                      _vm._v("上："),
                    ]),
                    _vm._v(" "),
                    _c("el-input-number", {
                      attrs: { min: 0 },
                      on: { change: _vm.updateItem },
                      model: {
                        value: _vm.itemInfo.position.pt,
                        callback: function ($$v) {
                          _vm.$set(_vm.itemInfo.position, "pt", $$v)
                        },
                        expression: "itemInfo.position.pt",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "flex",
                    staticStyle: { "margin-bottom": "5px" },
                  },
                  [
                    _c("div", { staticStyle: { "margin-right": "10px" } }, [
                      _vm._v("下："),
                    ]),
                    _vm._v(" "),
                    _c("el-input-number", {
                      attrs: { min: 0 },
                      on: { change: _vm.updateItem },
                      model: {
                        value: _vm.itemInfo.position.pb,
                        callback: function ($$v) {
                          _vm.$set(_vm.itemInfo.position, "pb", $$v)
                        },
                        expression: "itemInfo.position.pb",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "flex",
                    staticStyle: { "margin-bottom": "5px" },
                  },
                  [
                    _c("div", { staticStyle: { "margin-right": "10px" } }, [
                      _vm._v("左："),
                    ]),
                    _vm._v(" "),
                    _c("el-input-number", {
                      attrs: { min: 0 },
                      on: { change: _vm.updateItem },
                      model: {
                        value: _vm.itemInfo.position.pl,
                        callback: function ($$v) {
                          _vm.$set(_vm.itemInfo.position, "pl", $$v)
                        },
                        expression: "itemInfo.position.pl",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "flex",
                    staticStyle: { "margin-bottom": "5px" },
                  },
                  [
                    _c("div", { staticStyle: { "margin-right": "10px" } }, [
                      _vm._v("右："),
                    ]),
                    _vm._v(" "),
                    _c("el-input-number", {
                      attrs: { min: 0 },
                      on: { change: _vm.updateItem },
                      model: {
                        value: _vm.itemInfo.position.pr,
                        callback: function ($$v) {
                          _vm.$set(_vm.itemInfo.position, "pr", $$v)
                        },
                        expression: "itemInfo.position.pr",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "内部间距：" } }, [
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("上："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.searchPadding.pt,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.searchPadding, "pt", $$v)
                    },
                    expression: "itemInfo.searchPadding.pt",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("下："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.searchPadding.pb,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.searchPadding, "pb", $$v)
                    },
                    expression: "itemInfo.searchPadding.pb",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("左："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.searchPadding.pl,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.searchPadding, "pl", $$v)
                    },
                    expression: "itemInfo.searchPadding.pl",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("右："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.searchPadding.pr,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.searchPadding, "pr", $$v)
                    },
                    expression: "itemInfo.searchPadding.pr",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "外间距：" } }, [
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("上："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formMargin.mt,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formMargin, "mt", $$v)
                    },
                    expression: "itemInfo.formMargin.mt",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("下："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formMargin.mb,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formMargin, "mb", $$v)
                    },
                    expression: "itemInfo.formMargin.mb",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("左："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formMargin.ml,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formMargin, "ml", $$v)
                    },
                    expression: "itemInfo.formMargin.ml",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("右："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.formMargin.mr,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.formMargin, "mr", $$v)
                    },
                    expression: "itemInfo.formMargin.mr",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }